import { render, staticRenderFns } from "./AccessoryDetail.vue?vue&type=template&id=daf3d8e8&scoped=true&"
import script from "./AccessoryDetail.vue?vue&type=script&lang=js&"
export * from "./AccessoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf3d8e8",
  null
  
)

export default component.exports